import { useTranslation } from '@wix/wix-i18n-config';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useSelector, useStore } from 'react-redux';

import { TLocalesKeys } from '../../../../types';
import { logOpenArticleInHCAction } from '../../../bi';
import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { selectArticle } from '../../../common/selectors/helpCenter';
import { Page } from '../../../common/types';
import { experiments } from '../../../experiments';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import { HeaderActionsIcon } from './HeaderActionsIcon';

const widgetMaximizationDisabled = experiments.is('specs.helpwidget.widgetMaximization', 'false');

export const ArticleExternalLink: FC = () => {
  const store = useStore();
  const { t } = useTranslation();
  const currentArticle = useSelector(selectArticle);
  const currentPage = useCurrentPage();

  const onClick = useCallback(() => {
    if (!currentArticle) {
      return;
    }

    logOpenArticleInHCAction(store.getState(), { id: currentArticle.id });
  }, [store, currentArticle]);

  const shouldShowButton = currentPage === Page.Article && currentArticle?.url;

  if (widgetMaximizationDisabled || !shouldShowButton) {
    return null;
  }

  return (
    <HeaderActionsIcon
      onClick={onClick}
      dataHook={headerActionsDataHooks.articleExternalLink()}
      as="a"
      href={currentArticle.url}
      target="_blank"
      tooltipContent={t<TLocalesKeys>('header_action_icon_link')}
    >
      <ExternalLinkSmall />
    </HeaderActionsIcon>
  );
};
